// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail-component-container {
  position: relative;
}
.thumbnail-component-container img {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
}
.thumbnail-component-container .text-fallback {
  font-size: 16px;
  color: var(--gray);
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  height: 172px;
}
.thumbnail-component-container .provider {
  position: absolute;
  bottom: -2px;
  right: -2px;
  margin: 0;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.thumbnail-component-container .trend {
  height: 26px;
  width: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  bottom: -1px;
  border: 1px solid var(--base_color2);
  background-color: var(--trend);
}
.thumbnail-component-container .trend .icon {
  height: 14px;
  width: 14px;
  fill: var(--base_color2);
}
.thumbnail-component-container .thumbnail-no-image {
  max-height: 173px;
  background: var(--gray_insights3);
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/Thumbnail/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AACJ;AAEE;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;AAFJ;AAII;EACE,YAAA;EACA,WAAA;EACA,wBAAA;AAFN;AAME;EACE,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAJJ","sourcesContent":[".thumbnail-component-container {\n  position: relative;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n  }\n\n  .text-fallback {\n    font-size: 16px;\n    color: var(--gray);\n    display: flex;\n    font-weight: bold;\n    justify-content: center;\n    align-items: center;\n    height: 172px;\n  }\n\n  .provider {\n    position: absolute;\n    bottom: -2px;\n    right: -2px;\n    margin: 0;\n    width: 26px;\n    height: 26px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .trend {\n    height: 26px;\n    width: 26px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    position: absolute;\n    bottom: -1px;\n    border: 1px solid var(--base_color2);\n    background-color: var(--trend);\n\n    .icon {\n      height: 14px;\n      width: 14px;\n      fill: var(--base_color2);\n    }\n  }\n\n  .thumbnail-no-image {\n    max-height: 173px;\n    background: var(--gray_insights3);\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
